import { useEffect, useRef, useState } from "react";

/**
 * Anima un numero da valore precedente → target con easing cubic-out.
 * Ritorna il valore animato (intero). Sicuro per re-render frequenti.
 */
export function useCountUp(target, duration = 750) {
  const [val, setVal] = useState(() => Number(target) || 0);
  const prevRef = useRef(Number(target) || 0);

  useEffect(() => {
    const to = Number(target) || 0;
    const from = prevRef.current;
    if (from === to) { setVal(to); return; }
    let raf;
    const start = performance.now();
    const tick = (now) => {
      const p = Math.min((now - start) / duration, 1);
      const eased = 1 - Math.pow(1 - p, 3);
      setVal(Math.round(from + (to - from) * eased));
      if (p < 1) raf = requestAnimationFrame(tick);
      else prevRef.current = to;
    };
    raf = requestAnimationFrame(tick);
    return () => { if (raf) cancelAnimationFrame(raf); prevRef.current = to; };
  }, [target, duration]);

  return val;
}
